import { getSactchelIntentionalActionMiddleware } from 'middlewares/lib/getSatchelIntentionalActionMiddleware';
import { Modules } from 'mini-usercustomproperties';
import { satchelDiagnosticsMiddleware } from 'mini-diagnostic-store/lib/middlewares/satchelDiagnosticsMiddleware';
import { satchelWorkflowTrackerMiddleware } from 'mini-mail-workflow-tracking/lib/middlewares/satchelWorkflowTrackerMiddleware';

/**
 * Returns a list of Satchel middlewares for mail module.
 */
export const getSatchelMiddlewaresForMail = () => {
    const middlewares = [];

    // The following is the middleware to track user workflows.
    middlewares.push(satchelWorkflowTrackerMiddleware);

    // add the diagnostics middleware
    middlewares.push(satchelDiagnosticsMiddleware);

    // add the intentional actions middleware
    middlewares.push(getSactchelIntentionalActionMiddleware([Modules.MAIL, Modules.FILE]));

    return middlewares;
};
